<div class="new-connection" [formGroup]="addAccountForm" (keydown.Space)="$event.stopPropagation()">
  <div class="new-connection_step-container input-container">
    <div class="new-connection_step-title">1. Account Nickname</div>
    <div [ngClass]="{ hasError: isdisable === true }">
      <input
        formControlName="name"
        type="text"
        class="input-container_input input-container_input--thin"
        (blur)="duplicateNameValidator($event)"
      />
    </div>
  </div>
  <div class="new-connection_step-container">
    <div class="new-connection_step-title">
      2. Create your connection key in your marketplace
    </div>
    <app-button (click)="openAmazonMWSPage()" [buttonSize]="'action'"
      >Create MWS App Key</app-button
    >
  </div>
  <div class="new-connection_step-container">
    <div class="new-connection_step-title">
      3. Enter seller ID and token provided by your marketplace
    </div>
    <div class="new-connection_data-inputs">
      <div class="input-container">
        <label for="" class="input-container_label">Seller ID</label>
        <input
          type="text"
          formControlName="seller"
          class="input-container_input input-container_input--thin"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Marketplace</label>
        <select
          formControlName="marketPlace"
          type="text"
          class="input-container_input input-container_input--thin"
          placeholder="test"
        >
          <option value="" disabled selected hidden>Select</option>
          <option
            [value]="market.marketplaceid"
            *ngFor="let market of amazonMarkets"
          >
            {{ market.name }}
          </option>
        </select>
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">MWS Auth Token</label>
        <input
          formControlName="token"
          type="text"
          class="input-container_input input-container_input--thin"
        />
      </div>
    </div>
  </div>
  <div class="new-connection_note"><i class="fas fa-info-circle"></i> Additional integration monthly fee may apply</div>
  <div class="new-connection_action">
    <app-button (click)="cancel()" [buttonStyle]="'wire'">Cancel</app-button>
    <app-button
      [spin]="spinLoader"
      [isDisabled]="!addAccountForm.valid || isdisable === true"
      (click)="saveNewMarketplace()"
      >Save</app-button
    >
  </div>
</div>
